var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import VirtualList from "react-pearls-virtual-list";
import classnames from "classnames";
export default class ListView extends React.Component {
    constructor() {
        super(...arguments);
        this.scrollTo = (...args) => this.listviewRef.scrollTo(...args);
        this.getInnerViewNode = () => this.listviewRef.getRef();
    }
    render() {
        const _a = this.props, { prefixCls, className } = _a, restProps = __rest(_a, ["prefixCls", "className"]);
        const wrapCls = classnames(prefixCls, className);
        return <VirtualList ref={(el) => (this.listviewRef = el)} className={wrapCls} {...restProps}/>;
    }
}
ListView.defaultProps = {
    prefixCls: "pm-list-view",
    //listPrefixCls: "pm-list",
    width: "auto",
};
